import {BaseWidget} from "./BaseWidget";
import * as CapabilityType from '../constants/CapabilityType'
import * as translation from '../common/Translator'
import {translateMessage, translateRef} from '../common/Translator'
import {linkToRef} from "../routing/places";
import * as ObjectChecker from "../common/NamaCommon";
import {ajaxJSONWithoutError, ajaxJSONWithoutWait, isEmptyOrNull, isNotEmptyOrNull, isNullOrUndefined} from "../common/NamaCommon";
import * as NamaURLS from '../constants/NamaURLS';
import * as CommonFieldIds from '../constants/CommonFieldIds';
import * as ExpressionRelationship from '../constants/ExpressionRelationship';
import * as Operator from '../constants/Operator';
import * as CurrentUserUtil from "../login/Security";
import {JSCriteriaBuilder} from "../common/JSCriteriaBuilder";
import * as ClientCache from '../login/ClientCache'
import * as BaseDispatcher from '../actions/BaseDispatcher'
import {addContextFieldsToMap, createSearchContextInfo, FromGridAction, info, suggest, updateRelatedFields} from '../actions/BaseDispatcher'
import {PopupQuickCreator} from "../views/edit/PopupQuickCreator";
import ReferenceWidgetTemplate from "../compiled-templates/ReferenceWidgetTemplate";
import * as FieldType from "../constants/FieldType";
import {showTooltip} from "../common/TooltipUtil";
import * as notifier from "../common/ErrorsNotification";
import {createSearcherWindow, modelId} from "../grid/NamaGridWidget";
import {getFieldParentDetail} from "../common/Metadata";
import {createGenericValue} from "../actions/GenericValues";
import {themesWidgetBaseColors_} from "../common/GUIUtilities";
import * as ShowImageIn from "../constants/ShowImageIn";
import {addImgPartToName, mainFileImgTagByRecordID, shouldShowImage} from "../common/AttachmentLinkUtil";
import {fieldHasSuggestionProvider} from "./FieldWidgetCreator";
import {displayStringOfSuggestionItem} from "../common/SuggestionItemUtil";
import {getSuggestionEntityType, widgetRowIndex} from "./AutoCompleteWidget";

export function createListRefRequest(searchContextInfo, defaultCriteria, searchText, entityType, page, pageSize, extraCriteria) {
    /**
     *
     * @type {namaTypes.ListPageMatchingRequest}
     */
    let request = {};
    /**
     *
     * @type {namaTypes.FieldActionContextInfo}
     */
    let contextInfo = searchContextInfo;
    let criteria = new JSCriteriaBuilder();
    criteria = criteria.field(CommonFieldIds.COMMITE_BEFORE).equal(true);
    let addCriteria = function () {
        if (defaultCriteria)
            criteria = criteria.join(defaultCriteria);
        if (!searchText || !searchText.length)
            return;
        criteria = criteria.and();
        let codeOperator = ObjectChecker.getFirstNotEmptyObj(ClientCache.getCustomGUISettings().tooltipsAndReportsAndRevise.codeSearchOperator,
            Operator.Contains);
        let name1Operator = ObjectChecker.getFirstNotEmptyObj(ClientCache.getCustomGUISettings().tooltipsAndReportsAndRevise.name1SearchOperator,
            Operator.Contains);
        let name2Operator = ObjectChecker.getFirstNotEmptyObj(ClientCache.getCustomGUISettings().tooltipsAndReportsAndRevise.name2SearchOperator,
            Operator.Contains);
        criteria = criteria.openBraket();
        if (ClientCache.isMasterFile(entityType)) {
            criteria = criteria.field(CommonFieldIds.CODE).contains(searchText).operator(codeOperator).or()
                .field(CommonFieldIds.NAME1).contains(searchText).operator(name1Operator).or().field(CommonFieldIds.NAME2)
                .contains(searchText).operator(name2Operator);
            if (ClientCache.hasAltCode(entityType))
                criteria = criteria.or().field(CommonFieldIds.ALT_CODE).contains(searchText).operator(codeOperator);
            criteria = criteria.relationship(ExpressionRelationship.OR);
        } else {
            if (ClientCache.hasAltCode(entityType))
                criteria = criteria.field(CommonFieldIds.CODE).contains(searchText).operator(codeOperator).or()
                    .field(CommonFieldIds.ALT_CODE).contains(searchText).operator(codeOperator);
            else
                criteria = criteria.field(CommonFieldIds.CODE).contains(searchText).operator(codeOperator);
        }
        let settings = ClientCache.calcExtraReferenceSearchSettings(entityType);
        if (settings)
            settings.forEach((s) => criteria = criteria.or().field(s.fieldId).contains(searchText).operator(s.operator))
        criteria = criteria.closeBraket();
    };
    addCriteria();
    request.criteria = criteria;
    request.entityType = entityType;
    request.page = page;
    request.pageSize = pageSize;
    request.extraCriteria = extraCriteria;
    request.orderBy = "code";
    let req = {
        request: JSON.stringify(request),
        contextInfo: JSON.stringify(contextInfo)
    };
    return req;
}

export function listReferences(entityType, page, pageSize, searchText, searchContextInfo, extraCriteria, inChangeDimsDialog, defaultCriteria, suggestionRequest) {
    if (suggestionRequest)
        return ajaxJSONWithoutWait(NamaURLS.LIST_REFERENCES, suggestionRequest);
    if (!ClientCache.getCustomGUISettings().searchWithConnectedNamesInRefs)
        searchText = searchText.replace(" ", "%");

    let req = createListRefRequest(searchContextInfo, defaultCriteria, searchText, entityType, page, pageSize, extraCriteria);
    req.inChangeDimsDialog = inChangeDimsDialog;
    return ajaxJSONWithoutWait(NamaURLS.LIST_REFERENCES, req);
}

/**
 * @return {namaTypes.FieldActionContextInfo}
 * @param {string} entityType
 * @param {ExtendedFieldMetaData} fieldMetadata
 * @param {string} widgetId
 * @param {int} rowIndex
 * @param {EditPresenter} presenter
 */
export function createQuickCreateContextInfo(entityType, fieldMetadata, fieldId, lineNumber, presenter) {
    if (!presenter || !presenter.metaData)
        return null;
    let fieldInfo = info(fieldMetadata);
    let hasQuickCreator = fieldInfo && fieldInfo.hasQuickCreator;
    let quickCreateContextInfo = {};
    quickCreateContextInfo.souceLineLinumber = lineNumber;
    quickCreateContextInfo.sourceFieldId = fieldId;
    quickCreateContextInfo.sourceEntityType = entityType;
    quickCreateContextInfo.contextFields = {};
    quickCreateContextInfo.sourcFieldParentId = getFieldParentDetail(fieldId, presenter.metaData);
    let quickCreatorContextFields = [];
    if (hasQuickCreator && fieldInfo.quickCreatorFields != null)
        quickCreatorContextFields.push(...fieldInfo.quickCreatorFields);
    let quickCreator = ClientCache.getCustomGUISettings().tooltipsAndReportsAndRevise.customQuickCreator[entityType + "." + fieldId];
    if (quickCreator && quickCreator.contextFields)
        quickCreatorContextFields.push(...quickCreator.contextFields);
    addContextFieldsToMap(fieldId, quickCreatorContextFields, lineNumber, quickCreateContextInfo.contextFields, FromGridAction.No, null,
        null, presenter);
    let fieldValue = presenter.getFieldValue(fieldId, lineNumber);
    quickCreateContextInfo.sourceFieldValue = createGenericValue(fieldId, presenter.metaData, fieldValue, lineNumber);
    return quickCreateContextInfo;
}

export function referenceSuggestionTemp(d, isAutoCompleteSuggestion) {
    if (!d)
        return "";
    if (isAutoCompleteSuggestion)
        return displayStringOfSuggestionItem(d);
    let title = translateRef(d);
    let displayStr = d.code;
    if (d.code !== title)
        displayStr = d.code + " (" + title + ")";
    return addImgPartToName(d.entityType, d.id, displayStr, ShowImageIn.Suggestion, d);
}

export class ReferenceWidget extends BaseWidget {

    createElement(style) {
        return this.createHTML();
    }

    createHTML() {
        let that = this;
        let nameAttr = that.inputName ? that.inputName : "";
        return $(ReferenceWidgetTemplate({
            nameAttr: nameAttr,
            elementId: that.elementId
        }));
    }

    setNameLinkTextAndImage(value) {
        let that = this;
        that.linkContainer.parent().find("#mainFileImage").remove();
        if (!value || !value.id)
            return;
        let showIn = ShowImageIn.HeaderFields;
        if (that.insideGrid)
            showIn = ShowImageIn.GridColumns;
        if (shouldShowImage(that.entityType, showIn))
            that.linkContainer.parent().append(mainFileImgTagByRecordID(value, showIn, that.linkContainer));
    }

    shouldAddBlurHandler() {
        return false;
    }

    afterAttach() {
        super.afterAttach();
        let that = this;
        that.hideLinkContainer();
        that._firstFetch = true;
        if (that.insideGrid && that.fieldMetadata.fieldType === FieldType.Genericreference) {
            let colId = that.fieldMetadata.fieldId.substring(that.owner.id.length + 1, that.fieldMetadata.fieldId.length);
            that._entityType = that.cellOptions.model[modelId(that.id + ".entityType")] || "";
            that.initSuggestionSystemIfNeeded(that._entityType);
        }
        let model = defineModelForReferenceDataSource();
        that.findElement().kendoComboBox({
            filter: "contains", dataSource: {
                transport: {
                    read: (options) => {
                        that.readFromServer(options);
                    }
                },
                serverPaging: true,
                serverFiltering: true,
                schema: {
                    data: "page", total: "totalRecordsCount", model: model
                },
            },
            dataTextField: "$calcCode",
            dataValueField: "ref",
            template: (r) => referenceSuggestionTemp(r, that.isAutoCompleteSuggestion),
            clearButton: false,
            change: (e) => {
                that.updateValueAndWidget(that.readValueFromElement());
            },
            open: (e) => {
                that._comboOpen = true;
                that.combo().dataSource.read();
            },
            close: (e) => {
                that._comboOpen = false;
            }
        });
        that.combo().input.on("keydown", (e) => {
            if (e.keyCode === kendo.keys.DOWN) {
                that.startSearch();
            } else if (e.keyCode === 120) {
                if (that.owner && that.owner.entityType)
                    showTooltip(that.owner.entityType, that.id, -1, that.owner);
            } else if (e.keyCode === kendo.keys.ENTER || e.keyCode === kendo.keys.TAB) {
                that.chooseOrSearchForRef();
            }
        });
        that.combo().input.on("blur", (e) => {
            that.chooseOrSearchForRef();
        });
        that.combo().input.on("dblclick", (e) => {
            that.startSearch();
        });
        that.findComboContainer().find(".k-select")
            .before(`<a unselectable="on" class="k-select nama-ref-browse" id="${that.searchBtnId()}" tabindex="-1"><span class="k-icon k-i-search"></span></a>
                <a unselectable="on" class="k-select nama-ref-create" id="${that.createBtnId()}" role="button" tabindex="-1" ><span class="k-icon k-i-redo"></span></a>`);
        that.attachCreateNewHandler();
        that.attachSearchHandler();
        that.attachPopupIfNeeded();
    }

    startSearch() {
        let that = this;
        if (that._comboOpen)
            return;
        if (that.readOnlyCombo())
            return;
        that.combo().open();
    }

    readOnlyCombo(that) {
        return this.combo().element.attr("readonly") === "readonly";
    }

    updateValueAndWidget(ref) {
        let that = this;
        if (that.isAutoCompleteSuggestion && ref && ref.fieldsToUpdate)
            updateRelatedFields(ref.fieldsToUpdate, widgetRowIndex(that), that.owner.owner);
        that.onEdit(ref);
        that.renderValueInRefAndGoTo(ref);
    }

    chooseOrSearchForRef() {
        let that = this;
        that.valueFromFindByCode = undefined;
        let code = that.combo() ? that.combo().input.val() : null;
        let sameCode = this.oldValue && code === this.oldValue.code;
        let newEmptyCode = !this.oldValue && isEmptyOrNull(code);
        if (sameCode || newEmptyCode)
            return;
        let refFromElement = that.readValueFromElement();
        if (!refFromElement && isNotEmptyOrNull(code)) {
            ajaxJSONWithoutError(NamaURLS.FIND_REF_BY_CODE, {
                code: code, entityType: that.entityType,
                contextInfo: JSON.stringify(createSearchContextInfo("code", -1, {}))
            }, (ref) => {
                that.valueFromFindByCode = ref;
                that.updateValueAndWidget(ref);
            }, (error) => {
                if (ClientCache.isOpenCreate(that.id, that.owner.entityType))
                    that.openQuickCreator(null, (record) => {
                        let field = ClientCache.fetchFieldToSetValueInForOpenCreate(that.id, that.owner.entityType);
                        if (!field)
                            field = "code";
                        for (let subField of field.split(","))
                            record[subField] = code;
                    });
            });
        } else if (refFromElement) {
            that.updateValueAndWidget(refFromElement);
        }
    }

    attachPopupIfNeeded() {
        let that = this;
        if (!ClientCache.isOpenInPopup(that.id, that.owner.entityType))
            return;
        let link = that.find("#" + that.elementId + "link");
        let refFromElement = that.readValueFromElement();
        if (!refFromElement && link) {
            link.on("click", (e) => {
                if (e.ctrlKey)
                    return;
                e.preventDefault();
                let id = that.readValueFromElement().id;
                ajaxJSONWithoutError(NamaURLS.FIND_BY_ID, {
                    id: id, entityType: that.entityType,
                    contextInfo: null
                }, (ref) => {
                    new PopupQuickCreator(ref.data, null, null, that.owner.entityType, "", e).show();
                });
            })
        }
    }

    attachSearchHandler() {
        let that = this;
        that.find("#" + that.searchBtnId()).on("click", (e) => {
            e.preventDefault();
            let isDisabled = $(e.target).prop("disabled");
            if (isDisabled)
                return;
            if (that.readOnlyCombo())
                return;
            createSearcherWindow(that.owner, that.entityType, (ref) => {
                if (that.insideGrid) {
                    let colId = that.fieldMetadata.fieldId;
                    that.owner.refSelectionCallBack(colId, ref);
                } else {
                    that.onEdit(ref);
                    that.setValueInElement(ref);
                }
            }, that.createSearchContextInfo(), that.inChangeDimsDialog, that._defaultCriteria);
        });
    }

    attachCreateNewHandler() {
        let that = this;
        that.find("#" + that.createBtnId()).on("click", (e) => {
            let href = that.find("#" + that.createBtnId()).attr("href");
            if (href && href.length) {
                if (ClientCache.isOpenInPopup(that.id, that.owner.entityType)) {
                    e.preventDefault();
                    let id = that.readValueFromElement().id;
                    ajaxJSONWithoutError(NamaURLS.FIND_BY_ID, {
                        id: id, entityType: that.entityType,
                        contextInfo: null
                    }, (ref) => {
                        new PopupQuickCreator(ref.data, null, null, that.owner.entityType, "", e).show();
                    });
                }
            } else {
                e.preventDefault();
                /**
                 *
                 * @type {namaTypes.FieldActionContextInfo}
                 */
                let isDisabled = $(e.target).prop("disabled");
                if (isDisabled)
                    return;
                that.openQuickCreator(e);
            }
        });
    }

    openQuickCreator(e, initializerCallback) {
        let that = this;
        let contextInfo = createQuickCreateContextInfo(that.owner.entityType, that.fieldMetadata, that.id, -1, that.owner);
        ajaxJSONWithoutWait(NamaURLS.CREATE_NEW, {
            entityType: that.entityType,
            quickCreatorContextInfo: JSON.stringify(contextInfo)
        }, (result) => {
            let newRecord = result.data;
            if (initializerCallback)
                initializerCallback(newRecord);
            new PopupQuickCreator(newRecord, contextInfo, (record) => {
                that.updateValueAndWidget(record);
                that.setValueInElement(record);
            }, that.owner.entityType, null, e).show();
        });
    }

    hideLinkContainer() {
        let that = this;
        that.linkContainer = that.find("." + that.elementId + "linkContainer");
        that.comboContainer = that.findComboContainer();
        that.linkContainer.css("display", "none");
        that.comboContainer.removeClass("col-md-4");
        that.comboContainer.addClass("col-md-12");
    }

    findComboContainer() {
        return this.find("." + this.elementId + "comboContainer");
    }

    setValueInElement(value) {
        this.comboContainer.removeClass("col-md-4");
        this.comboContainer.addClass("col-md-12");
        this._valueBeingSet = value;
        let that = this;
        if (!that.combo()) {
            setTimeout(() => {
                that.setValueInElement(value);
            });
            return;
        }
        that._firstFetch = true;
        that.combo().dataSource.read().then(
            () => {
                try {
                    let code = value ? value.code : "";
                    code = code || "";
                    if (value)
                        that.combo().select((i) => {
                            return i.id === value.id;
                        });
                    else
                        that.combo().select(-1);
                    that.combo().value(code);
                } finally {
                    that._valueBeingSet = undefined;
                }
            });
        that.renderValueInRefAndGoTo(value);
    }

    renderValueInRefAndGoTo(value) {
        let that = this;
        if (!value)
            value = {};
        let title = translation.translateRef(value);
        let link = that.find("#" + that.elementId + "link");
        link.text(title);
        link.attr("onmouseover", `previewAttachment(this, null, '${value[CommonFieldIds.ENTITY_TYPE]}', '${value[CommonFieldIds.ID]}');`);
        link.attr("onmouseout", "previewAttachmentMouseOut(this);");
        let code = value["code"];
        if (!title || code === title) {
            that.linkContainer.css("display", "none");
            that.comboContainer.removeClass("col-md-4");
            that.comboContainer.addClass("col-md-12");
            that.findComboContainer().removeClass("nama-ref-hide-go-to");
            that.find("#" + that.createBtnId()).attr("href", linkToRef(value));
        } else {
            if (that.insideGrid) {
                // that.findElement().closest(".k-combobox").addClass("ref-input");
            } else {
                this.comboContainer.removeClass("col-md-12");
                this.comboContainer.addClass("col-md-4");
            }
            that.linkContainer.css("display", "block");
            that.linkContainer.css("background-color", themesWidgetBaseColors_())
            that.findComboContainer().addClass("nama-ref-hide-go-to");
        }
        that.setNameLinkTextAndImage(value);
        link.attr("href", linkToRef(value));
        link.parent().attr("title", title);
    }

    readValueFromElement() {
        let that = this;
        if (that._valueBeingSet)
            return that._valueBeingSet;
        let index = that.combo().select();
        if (index < 0) {
            if (that.isAutoCompleteSuggestion)
                return that.combo().input.val();
            else {
                let data = that.combo().dataSource.data();
                if (ObjectChecker.isNotEmptyOrNull(data)) {
                    let dataWithCode = data.filter(item => item["code"] == that.combo().value());
                    if (dataWithCode && dataWithCode.length)
                        return dataWithCode[0];
                    return null;

                }
                return null;
            }
        }
        let dataItem = that.combo().dataItem(index);
        if (that.isAutoCompleteSuggestion) {
            let fieldsToUpdate = dataItem.fieldsToUpdate;
            dataItem = dataItem.value.valuesMap;
            dataItem.fieldsToUpdate = fieldsToUpdate;
        }
        return dataItem;
    }

    valueOrParsedValue(value) {
        return value;
    }

    get _defaultCriteria() {
        if (this.defaultCriteria)
            return this.defaultCriteria();
        return undefined;
    }

    readFromServer(options) {
        let that = this;
        if (that._firstFetch) {
            that._firstFetch = false;
            if (that.oldValue && that.oldValue.id)
                options.success({page: [that.oldValue], total: 1});
            else if (that._valueBeingSet && that._valueBeingSet.id)
                options.success({page: [that._valueBeingSet], total: 1});
            else
                options.success({page: [], total: 0});
            return;
        }
        if (!CurrentUserUtil.userCan(that.entityType, CapabilityType.ListView)) {
            options.success({page: [], total: 0});
            return;
        }
        let searchText = "";
        if (options.data && options.data.filter && options.data.filter.filters && options.data.filter.filters.length)
            searchText = options.data.filter.filters[0].value;
        let minSearchQueryLength = CurrentUserUtil.fetchMinSearchQueryLength(that.entityType);
        if (searchText.length < minSearchQueryLength) {
            that.onResultReadFromServer(options, {page: [], total: 0});
            return;
        }
        let page = (that.combo().dataSource.page() || 1) - 1;
        let pageSize = that.combo().dataSource.pageSize() || 25;
        if (!that.entityType) {
            notifier.showError(translateMessage("Entity Type is not provided"));
            options.success({page: [], total: 0});
            return;
        }
        if (that.isAutoCompleteSuggestion) {
            let suggestionList = [];
            suggest(that.owner.owner, that.id, widgetRowIndex(that), that.readValueFromElement(), getSuggestionEntityType(that)).then((result) => {
                for (let suggestItem of result.suggestions) {
                    suggestionList.push(suggestItem);
                }
                let result2 = {page: suggestionList, total: suggestionList.length};
                that.onResultReadFromServer(options, result2)
            }).catch((e) => options.error(e));
            return;
        }
        listReferences(that.entityType, page, pageSize, searchText, that.createSearchContextInfo(), that.extraCriteria, that.inChangeDimsDialog, that._defaultCriteria).then((page) => {
            let result = {page: page, total: page.length};
            that.onResultReadFromServer(options, result)
        });
    }

    onResultReadFromServer(options, result) {
        if (result && result.total === 0 && this.valueFromFindByCode)
            result = {page: [this.valueFromFindByCode], total: 1};
        options.success(result);
    }

    createSearchContextInfo() {
        return BaseDispatcher.createSearchContextInfo(this.id, -1, this.owner);
    }

    get entityType() {
        return calcReferenceEntityType(this._entityType, this.fieldMetadata);
    }

    changeEntityType(entityType, resetValues) {
        let that = this;
        if (entityType === that.entityType || isNullOrUndefined(entityType) || entityType.startsWith("$"))
            return;
        that._entityType = entityType;
        that._selectorPopupPreferences = null;
        let currentValue = that.readValueFromElement();
        if (resetValues)
            that.setValue({entityType: entityType})
        else if (currentValue)
            currentValue.entityType = entityType;
        that.setEnabled(true);
        that.initSuggestionSystemIfNeeded(entityType);
    }

    /**
     *@returns {kendo.ui.ComboBox}
     */
    combo() {
        return this.findElement().data("kendoComboBox");
    }

    setEnabled(enabled) {
        if (enabled === "Enabled" || enabled === true) {
            this.find("#" + this.searchBtnId()).prop('disabled', false);
            this.find("#" + this.createBtnId()).prop('disabled', false);
            this.combo().readonly(false);
        } else {
            this.find("#" + this.searchBtnId()).prop('disabled', true);
            this.find("#" + this.createBtnId()).prop('disabled', true);
            this.combo().readonly(true);
        }

    }

    searchBtnId() {
        return this.elementId + "search";
    }

    createBtnId() {
        return this.elementId + "createNew";
    }

    referenceTable() {
        return this.entityType;
    }

    initSuggestionSystemIfNeeded(entityType) {
        let that = this;
        if (!that.insideGrid)
            return;
        if (fieldHasSuggestionProvider(that.fieldMetadata, entityType)) {
            that.isAutoCompleteSuggestion = true;
        }
    }
}

export function calcReferenceEntityType(currentEntityType, fieldMetaData) {
    if (currentEntityType)
        return currentEntityType;
    if (fieldMetaData.referencedEntityType)
        return fieldMetaData.referencedEntityType;
    if (fieldMetaData.defaultEntityType)
        return fieldMetaData.defaultEntityType;
    if (fieldMetaData.allowedValues && fieldMetaData.allowedValues.length === 1)
        return fieldMetaData.allowedValues[0];
}

export function defineModelForReferenceDataSource() {
    let model = kendo.data.Model.define({});
    Object.defineProperty(model.prototype, "ref", {
        enumerable: false, configurable: true, get: function () {
            return this;
        }, set: function (value) {

        }
    });
    Object.defineProperty(model.prototype, "$calcCode", {
        enumerable: false, configurable: true, get: function () {
            return this.text && this.text.code ? this.text.code : this.code;
        }, set: function (value) {
        }
    });
    model.prototype.toString = function () {
        return this.code;
    };
    Object.defineProperty(model.prototype, "title", {
        enumerable: false, configurable: true, get: function () {
            return translateRef(this);
        }, set: function (value) {
        }
    });
    return model;
}